import {ISymbolPosition} from "../../core/reel/ReelInterfaces";
import {TrueGritSymbol, TrueGritSymbolStates} from "../reels/TrueGritSymbol";
import {TrueGrit} from "../TrueGrit";
import {TrueGritStackedWildSymbol} from "../reels/TrueGritStackedWildSymbol";

/**
 * Created by jonas on 2021-02-19.
 */

export class SymbolUtils {

    public static createSymbol(symbolName:string, state:TrueGritSymbolStates, symbolPositionData:ISymbolPosition):TrueGritSymbol {

        if(symbolName !== "S" && (state == TrueGritSymbolStates.SPIN_IN || state == TrueGritSymbolStates.SPIN_OUT)) {
            state = TrueGritSymbolStates.SPIN;
        }

        if(symbolName == "W2") {
            return new TrueGritStackedWildSymbol().init(TrueGritSymbolStates.NORMAL);
        }

        if(symbolName == "T") {
            const isLow:boolean = !!TrueGrit.model.highLowTransform?.isLow;
            symbolName = isLow ? "T2" : "T";
            return new TrueGritSymbol(symbolName).init(state);
        }

        if(symbolName == "M0") {
            return TrueGrit.trueGritGritGirlSymbols.getGritGirlSymbol(symbolPositionData).init(state);
        }

        if(symbolName == "S") {
            return TrueGrit.trueGritScatterSymbols.getScatterSymbol(symbolPositionData).init(state);
        } else {
            return new TrueGritSymbol(symbolName).init(state);
        }
    }
}